import { render, staticRenderFns } from "./ProgramacionInforme.vue?vue&type=template&id=19a56649&scoped=true&"
import script from "./ProgramacionInforme.vue?vue&type=script&lang=ts&"
export * from "./ProgramacionInforme.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a56649",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('19a56649', component.options)
    } else {
      api.reload('19a56649', component.options)
    }
    module.hot.accept("./ProgramacionInforme.vue?vue&type=template&id=19a56649&scoped=true&", function () {
      api.rerender('19a56649', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/ProgramacionInforme.vue"
export default component.exports